exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slotmanagement_bottomSheet.v-dialog:not(.v-dialog--fullscreen){max-height:100%}", ""]);

// exports
